import { useEffect, useRef } from "react";
import ReactQuill from "react-quill";

import { EditorOpt } from "scripts/settings";

import "react-quill/dist/quill.snow.css";

const Component = (props) => {
	const editorRef = useRef();

	const componentDidMount = () => {
		editorRef.current.editor.format("direction", "rtl");
		editorRef.current.editor.format("align", "right");
	};

	useEffect(componentDidMount, []);

	return (
		<ReactQuill
			ref={editorRef}
			{...props}
			{...EditorOpt}
		/>
	);
};

export default Component;
